<template>
  <div id="main-content" class="add-bus">
    <el-col :offset="1" :span="22" >
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <div class="align-center">
          <el-button type="success" @click="goToEdit()">{{ $t('common.edit') }}</el-button>
      </div>
      <form class="edit-category">
        <el-row >
          <el-col :span="6">
            <span class="required-star">* </span><span class="form-lable">{{ $t('categoryM.form.name') }}</span>
          </el-col>
          <el-col  :span="18">
            <div class="text-left mt-2">
              {{category.name}}
            </div>
          </el-col>
        </el-row>
        <el-row class="mt-4">
          <el-col :span="6">
            <span class="required-star">* </span><span class="form-lable">{{ $t('categoryM.note') }}</span>
          </el-col>
          <el-col  :span="18">
           <div class="text-left mt-2">{{category.note}}</div>
          </el-col>
        </el-row>
        <el-row class="mt-3">
          <el-col :span="6">
            <span class="required-star">* </span><span class="form-lable">{{ $t('categoryM.form.listFile') }}</span>
          </el-col>
          <el-col :span="24">
            <table class="bus-list">
              <tr>
                <th width="5%">#</th>
                <th width="30%">{{ $t('common.title') }}</th>
                <th width="20%">{{ $t('fileM.password') }}</th>
                <th width="15%">{{ $t('common.file') }}</th>
              </tr>
              <tr v-for="(attachment, index) in category.files" :key="attachment.id" :class="{'file-detail':$route.query.file_id=== attachment.id }">
                <td width="5%">{{ index + 1 }}</td>
                <td>
                  <span>{{ attachment.title }}</span>
                </td>
                <td>
                  <el-form>
                    <el-switch disabled v-model="attachment.status" :active-value="1" :inactive-value="0" class="mr-2"></el-switch>
                    <el-input   style="width: 70%" show-password :value="attachment.password"></el-input>
                  </el-form>
                </td>
                <td>
                  <el-button type="success" icon="el-icon-view" @click="goToViewFile(attachment.file_url)">{{ $t('common.view') }}</el-button>
                </td>
              </tr>
            </table>
          </el-col>
        </el-row>
      </form>
    </el-col>
  </div>
</template>
<script>
import PageTitle from "@/components/PageTitle";
export default {
  components:{
    PageTitle
  },
  data(){
    return{
      title:'categoryM.titleDetail',
      backLink: '/category-management',
      isUploadFile: 0,
      listFiles: [],
      isEdit: false,
      category:{
        name:'',
        files: [],
        note: ''
      },
      new_file:{
        title: null,
        file_url: null
      },
      files: [],
      arrayTest1:[
        {value:null},
        {value:null},
      ]
    }
  },
  created() {
    if(this.$route.params.id){
      this.getDataById(this.$route.params.id)
      this.isEdit = true
      if(this.$route.query.file_id){
       this.backLink = '/file-management'
      }else{
        this.backLink= '/category-management'
      }
    }
  },
  methods:{
    goToEdit(){
      this.$router.push({name:'category-management-edit', query: {id: this.$route.params.id}})
    },
    goToViewFile(file_url) {
      window.open(file_url, '_blank')
    },
    getDataById(id){
      let successCallback = async (response) => {
        if(response.status ===200){
          const {file_category } = response.data.data
          this.category = file_category
          this.listFiles = file_category.files.map(el=> { return el.file_url})
        }
      }
      let errorCallback = () => {}
      let payload = {
        category_id: id,
        successCallback,
        errorCallback
      }
      this.$store.dispatch('CategoriesFile/getDetailCategory', payload)
    }
  }
}
</script>
<style lang="scss">
.file-detail{
  background-color: #adccea;
}
.edit-category{
  padding: 1rem 5rem;
}
.text-add-file{
  line-height: 40px;
  margin-left: 10px;
  font-size: 22px
}
.icon-move{
  font-weight: bold;
  font-size: 30px;
  margin: .1rem 0 0 .8rem;
  cursor: pointer;
}
.flex-end{
  display: flex;
  justify-content: flex-end;
  justify-items: center;
}
</style>
